const MESSAGES = {
  added_item_success: 'Item was added to the cart',
  fill_out_item: 'Please fill in {field}',
  success_placing: 'Thanks for your {label}. The confirmation is sent to your E-Mail.',
  success_config_update: 'Config updated',
  success_user_update: 'Your user data were updated',
  qr_found_searching: 'QR-Code found. Searching for product...',
  product_not_found: 'Product not found...',
  password_not_same: 'Passwords are not even',
  password_at_least_digits: 'Password should be at least {count} digits',
  successful_password_reset: 'Your password was changed',
  no_user: 'User not found',
  missing_params: 'Missing Params',
  password_forgot_mail_sent: 'Success! An E-Mail was sent.',
  no_email: 'No E-Mail address found.',
  password_change_failed: 'Password change failed',
  mixer_request_success: 'Your request was sent successfully.',
  sand_amount_under_100: 'You need 100% of sand amount',
};

export default MESSAGES;
